import {
  SOFTLINE_CONFIG_ARBEITSBERICHT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_INPUT,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST,
  SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY,
} from '@softapps/gewerbe/arbeitsbericht';
import { SOFTLINE_CONFIG_ARBEITSSCHEIN } from '@softapps/gewerbe/arbeitsschein';
import {
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic';
import { default as arbeitsberichtEditDefinition } from './definitions/arbeitsbericht/edit.json';
import { default as arbeitsberichtInputDefinition } from './definitions/arbeitsbericht/input.json';
import { default as arbeitsberichtListDefinition } from './definitions/arbeitsbericht/list.json';
import { default as arbeitsberichtQueryDefinition } from './definitions/arbeitsbericht/query.json';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

export const customerConfig: CustomerConfig = {
  version: '0.0.0',
  id: 'at.softline.steirerhaus.softline',
  name: 'Steirerhaus Softline',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'steirerhaus' },
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'steirerhaus',
        name: 'Steirerhaus',
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_ARBEITSSCHEIN,
      useValue: {
        hideWeatherSection: true,
        showCopyAction: false,
        enablePositionCopy: true,
        showDrawPad: true,
        showMusterQuickLink: false,
        showVermerkInput: true,
      },
    },
    {
      provide: SOFTLINE_CONFIG_ARBEITSBERICHT,
      useValue: {
        clickAction: 'navigate',
        useSecondaryBorderStyle: true,
        hideEntryInDetails: true,
        allowDelete: true,
        actions: [
          {
            label: 'Auftrag Scannen',
            icon: 'fas fa-barcode',
            actionType: 'scanOrder',
          },
          {
            label: 'Letzte Objekte',
            icon: 'fas fa-history',
            actionType: 'recentObjects',
          },
        ],
      },
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST,
        definition: arbeitsberichtListDefinition,
        priority: 1,
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_ARBEITSBERICHT_INPUT,
        definition: arbeitsberichtInputDefinition,
        priority: 1,
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_ARBEITSBERICHT_EDIT,
        definition: arbeitsberichtEditDefinition,
        priority: 1,
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_ARBEITSBERICHT_QUERY,
        definition: arbeitsberichtQueryDefinition,
        priority: 1,
      },
      multi: true,
    },
  ],
};
